export function initMultiselectRequiredLabels()
{
	const requiredMultiSelects = document.querySelectorAll('[data-select-required]');

	requiredMultiSelects.forEach(requiredMultiSelect => {
		const parent = requiredMultiSelect.closest('.form-group');

		if (parent) {
			const label = parent.querySelector('label');

			if (label) {
				label.classList.add('required');
			}
		}
	});
}
